import React, { ComponentProps } from 'react'
import {
  useFormContext,
  get,
  RegisterOptions,
  Controller,
} from 'react-hook-form'
import { SelectBox, SelectBoxOption } from "@moneyforward/mfx_biz_react_components";

type Props = ComponentProps<typeof SelectBox> & {
  name: string
  registerOptions?: RegisterOptions
}

const InnerFormSelectBox = (
  props: Props,
  ref: React.ForwardedRef<HTMLSelectElement>,
) => {
  const { control, formState } = useFormContext()
  const { errors } = formState
  const { registerOptions, options, value, ...inputProps } = props

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field }) => {
        // [react-hook-form]と[react-select]のデータ連動のためアイテムを取得しておく
        const selectedValue = options?.find(
          (option) => option.value === field.value,
        )
        return (
          <SelectBox
            {...inputProps}
            {...field}
            options={options}
            value={(selectedValue as SelectBoxOption) || value}
            onChange={(option) => {
              field.onChange(option.value)
              inputProps.onChange && inputProps.onChange(option.value)
            }}
            onBlur={(option) => {
              field.onBlur()
              inputProps.onBlur && inputProps.onBlur(option.value)
            }}
            ref={(el) => {
              field.ref(el)
              if (typeof ref === 'function') {
                ref(el)
                return
              }
              if (ref) {
                ref.current = el
              }
            }}
            isError={get(errors, props.name)}
          />
        )
      }}
      rules={registerOptions}
    />
  )
}

export const FormSelectBox = React.forwardRef(InnerFormSelectBox)
